'use client'

import { usePathname } from 'next/navigation'

import Footer from '../nav/footer'

export function ConditionalFooter() {
  const pathname = usePathname()
  const isHomePage = pathname === '/' || pathname === ''
  const isServicesPage = pathname === '/services'
  const isCaseStudiesPage = pathname === '/case-studies'
  const isWorkshopsPage = pathname === '/workshops'
  const isPostSection = pathname === '/post' || pathname?.startsWith('/post/')
  const isContactPage = pathname === '/contact-us'
  const isAboutPage = pathname === '/about-us'
  const isWorkshopDetailPage =
    pathname?.startsWith('/workshops/graduate-data-eng-workshop') ||
    pathname?.startsWith('/workshops/modern-data-eng-workshop') ||
    pathname?.startsWith('/workshops/lead-dataeng-workshop')
  const isAiWorkshopsPage = pathname?.startsWith('/workshops/ai')
  const isWorkshopRegister =
    pathname === '/workshops/register' || pathname === '/workshops/confirmation'
  const isSpotlights = pathname === '/spotlights' || pathname?.startsWith('/spotlights/')
  const isCaseStudyDetail = pathname?.startsWith('/case-studies/')
  const isPrivacyPage = pathname === '/privacy'
  const isCallbackPage = pathname === '/callback'

  // Homepage and redesigned pages have their own footer
  if (
    isHomePage ||
    isServicesPage ||
    isCaseStudiesPage ||
    isWorkshopsPage ||
    isPostSection ||
    isContactPage ||
    isAboutPage ||
    isWorkshopDetailPage ||
    isAiWorkshopsPage ||
    isWorkshopRegister ||
    isSpotlights ||
    isCaseStudyDetail ||
    isPrivacyPage ||
    isCallbackPage
  ) {
    return null
  }

  return <Footer />
}
